<app-preloader *ngIf="isLoading"></app-preloader>

<div [ngClass]="{'main-content': true, 'content-blurred': isLoading}">
  <router-outlet />
</div>
